<template>
  <div v-loading="showFlag">
    <!--  注文製品選択画面 -->
    <t-card>
      <div :style="{ height: basicHeight + 'px' }">
        <t-form
          :model="searchConditionForm"
          label-position="right"
          label-width="80px"
        >
          <t-row
            type="flex"
            justify="center
          "
          >
            <!-- 仕入先 -->
            <t-col :span="5">
              <t-form-item
                :label="$t('resource.TRANSPORT.SUPPLIER_COMPANY')"
                class="marginBottom"
              >
                <t-select
                  v-model="searchConditionForm.searchCrbSupCode"
                  placeholder=""
                  class="commonDialog"
                  disabled
                >
                  <t-option
                    v-for="item in supCodeList"
                    :key="item.supCode"
                    :label="item.supCode + ':' + item.supAbbreviation"
                    :value="item.supCode"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
            <!-- 注文No -->
            <t-col :span="5">
              <t-form-item
                :label="$t('resource.JP_RECEIVE.ORDER_NO')"
                class="marginBottom"
              >
                <t-input
                  v-model="searchConditionForm.searchOrderNo"
                  class="commonDialog"
                  :clearable="true"
                  maxLength="25"
                >
                </t-input>
              </t-form-item>
            </t-col>

            <!-- 図番 -->
            <t-col :span="5">
              <t-form-item
                :label="$t('resource.JP_RECEIVE.PRODUCT_DRAW_NO')"
                class="marginBottom"
              >
                <t-input
                  v-model="searchConditionForm.searchDrawNo"
                  class="commonDialog"
                  maxLength="30"
                  :clearable="true"
                >
                </t-input>
              </t-form-item>
            </t-col>

            <!-- 注文日 -->
            <t-col :span="7" class="left">
              <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
              <!-- 「手配日　⇒　仕入先納期」の変更 -->
              <!-- <t-form-item
                :label="$t('resource.JP_RECEIVE.ORDER_DATE')"
                class="marginBottom"
              >

              <t-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="～"
                  start-placeholder="開始日"
                  end-placeholder="終了日"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  :editable="false"
                  style="margin-top: 3px; width: 90%"
                  class="date_icon_center"
                  :clearable="false"
                />-->
              <t-form-item
                :label="$t('resource.JP_RECEIVE.SUPPLIER_DUE_DATE')"
                class="marginBottom"
                label-width="120px"
              >
                <t-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="～"
                  start-placeholder="開始日"
                  end-placeholder="終了日"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  :editable="false"
                  style="margin-top: 3px; width: 90%"
                  class="date_icon_center"
                />
                <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
              </t-form-item>
            </t-col>

            <t-col :span="3" class="center">
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                ref="searchBtn"
                class="dialogButton_120_40"
                @click="SearchClick()"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.sys.search") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <t-table
                ref="jpReceTransSelectForm"
                :data="jpReceTransSelectForm"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                :row-class-name="rowClassName"
                highlight-current-row
                border
                fit
              >
                <!-- 選択ボックス -->
                <t-table-column
                  prop="selected"
                  type="selection"
                  :selectable="selectableCheck"
                  class-name="cell_txt_center"
                >
                </t-table-column>
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                </t-table-column>

                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_備考機能の追加 -->
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 共通備考の調整 -->
                <!-- <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  class="cell_txt_center"
                  :min-width="100"
                >
                  <template slot-scope="scope">
                    <div class="button-container">
                      <t-tooltip placement="bottom" effect="light">
                        <div
                          slot="content"
                          class="tooltip-content"
                          v-html="
                            formatRemarksShowProc(scope.row.aodProdRemarksSum)
                          "
                        ></div>
                        <t-button
                          :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                          icon="el-icon-search"
                          size="small"
                          circle
                        >
                        </t-button>
                      </t-tooltip>
                    </div>
                  </template>
                </t-table-column> -->
                <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  prop="aodProdRemarksSum"
                  :class-name="'cell_txt_center'"
                  :width="getRemarksColumnWidthProc()"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div class="bikouDiv">
                      <!-- 備考表示 -->
                      <span class="bikouText">
                        {{ scope.row.aodProdRemarksSum }}
                      </span>
                    </div>
                  </template>
                </t-table-column>
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right">
          <t-row type="flex" justify="end">
            <div>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
              <t-col
                :span="
                  parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_TWO'))
                "
              >
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  @click="confirmClick"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { t } from "@/locales";
import { getJpReceInitList, getOrderSelect } from "@/services/jpReceive";
import {
  formatDateToString,
  formatRemarksShow,
  formatStringToCurrency,
  getDialogContentHeight,
  getIconType,
  getNextMonthDate,
  getPreviousMonthDate,
  getRemarksColumnWidth,
  ShowMergeExKbn,
} from "@/utils/comFunction";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";

import {
  DIALOG_LINE_HEIGHT,
  NORMAL_PROD,
  STR_EMPTY,
  STR_ONE,
  STR_ZERO,
} from "@/utils/const";
export default {
  data() {
    return {
      //検索条件
      dateRange: [],
      searchConditionForm: {
        searchCrbSupCode: "", // 仕入先
        searchOrderNo: "", // 注文No.
        searchDrawNo: "", //図番
        searchStartDate: "", // 入荷日(開始日)
        searchEndDate: "", // 入荷日(終了日)
      },

      //日本入荷一覧選択情報
      jpReceTransSelectForm: [
        {
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // obDate: "", // 注文日
          odDueDate: "", // 仕入先納期
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          jrdOrderNo: "", // 注文No
          aodProdName: "", // 品名,
          aodProdDrawNo: "", //図番
          odProdQuantity: "", //数量
          aodProdUnit: "", //単位
          // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
          // aodProdMaterial: "", //素材
          // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑
          aodProdTreatment: "", //処理
          odUPrice: "", //単価(JPY)
          aodProCompleteNum: "", //入荷済み数
          jrdReceRemainQty: "", //入荷残
          jrbSupCode: "", //仕入先
        },
      ],

      // 仕入先リスト
      supCodeList: [],

      //注文製品選択情報(⇒日本入荷詳細画面（大連以外の工場）)
      selectedProcForm: [],

      //テーブルの列
      columns: [
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // 「手配日」⇒「仕入先納期」の変更
        // // 注文日
        // {
        //   prop: "obDate",
        //   label: t("resource.JP_RECEIVE.ORDER_DATE"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_center",
        // },
        // 仕入先納期
        {
          prop: "odDueDate",
          label: t("resource.JP_RECEIVE.SUPPLIER_DUE_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        {
          // 注文No
          // prop: "jrdOrderNo",
          prop: "jrdOrderNoShow",
          label: t("resource.JP_RECEIVE.ORDER_NO"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // ミスミ関連区分
        {
          prop: "aodMisumiKbnStr",
          label: t("resource.ORDER.MSM_KBN"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.JP_RECEIVE.PRODUCT_NAME"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.JP_RECEIVE.PRODUCT_DRAW_NO"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 数量
        {
          prop: "odProdQuantity",
          label: t("resource.JP_RECEIVE.PRODUCT_COUNT"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },

        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.JP_RECEIVE.PRODUCT_UNIT"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },

        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
        // // 素材
        // {
        //   prop: "aodProdMaterial",
        //   label: t("resource.JP_RECEIVE.PRODUCT_MATERIAL"),
        //   width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // // 処理
        // {
        //   prop: "aodProdTreatment",
        //   label: t("resource.JP_RECEIVE.PRODUCT_TREAT"),
        //   width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_left",
        // },
        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑
        // 単価(JPY)
        {
          prop: "odUPrice",
          label: t("resource.JP_RECEIVE.UNIT_PRICE"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 入荷済み数
        {
          prop: "aodProCompleteNum",
          label: t("resource.JP_RECEIVE.RECE_COMPLETE_QUANTITY"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },

        // 入荷残
        {
          prop: "jrdReceRemainQty",
          label: t("resource.JP_RECEIVE.RECE_REMAIN_QUANTITY"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
      ],

      showFlag: false,

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,
      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        20
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,
      jrbReceNo: this.jpReceNo,
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    tableData: {
      Type: Object,
      default: null,
    },
    supCode: {
      Type: Object,
      default: null,
    },
    //運送製品選択画面の検索条件
    selectedSearchForm: {
      Type: Object,
      default: null,
    },

    jpReceNo: {
      Type: Object,
      default: null,
    },
  },
  mounted() {
    // 初期化
    this.init();
    // 列幅に自動調整
    setColumnWidth(this.columns, this.jpReceTransSelectForm);
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        20
      );
    },

    // 初期化
    init() {
      this.showFlag = true;
      getJpReceInitList()
        .then((res) => {
          //仕入先リストに追加
          this.supCodeList = res.jpOfiSuprCpyList;

          //運送製品選択画面の検索条件が空しない場合
          if (
            !!this.selectedSearchForm &&
            this.selectedSearchForm != STR_EMPTY
          ) {
            this.searchConditionForm = [];
            this.searchConditionForm = this.selectedSearchForm;
            if (this.searchConditionForm.searchStartDate == STR_EMPTY) {
              this.dateRange = [];
            } else {
              this.dateRange = [
                this.searchConditionForm.searchStartDate,
                this.searchConditionForm.searchEndDate,
              ];
            }
          } else {
            //日付初期化
            this.dateInit();
          }
          if (this.supCode) {
            this.searchConditionForm.searchCrbSupCode = this.supCode;
          }

          this.SearchClick();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        });
    },

    //日付初期化
    dateInit() {
      //システム日付
      var systemDate = new Date();
      //日付初期値の設定
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // this.dateRange = [getPreviousMonthDate(systemDate), systemDate];
      this.dateRange = [systemDate, getNextMonthDate(systemDate)];
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
    },

    // 検索
    SearchClick() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      // 検索条件の処理
      this.updateSearchForm();

      getOrderSelect({
        OrderSelectSearchForm: this.searchConditionForm,
        jrbReceNo: this.jrbReceNo,
      })
        .then((res) => {
          this.jpReceTransSelectForm = res.jpReceDetailInfoList;

          this.checkedProcess();

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
          // 列幅に自動調整
          setColumnWidth(this.columns, this.jpReceTransSelectForm);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })

        .finally(() => {
          this.showFlag = false;
        });

      if (typeof this.$refs.searchBtn !== "undefined") {
        // フォーカス削除
        this.$refs.searchBtn.$el.blur();
      }
    },

    // データ処理
    dataProcess() {
      this.jpReceTransSelectForm.map((item) => {
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // // 注文日
        // if (item.obDate) {
        //   item.obDate = formatDateToString(item.obDate);
        // }
        // 仕入先納期
        if (item.odDueDate) {
          item.odDueDate = formatDateToString(item.odDueDate);
        }
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        item.odUPrice = formatStringToCurrency(item.odUPrice);
        //入荷残
        item.jrdReceRemainQty = item.odProdQuantity - item.aodProCompleteNum;
      });
    },

    //チェックボックスの選択処理
    checkedProcess() {
      if (!!this.tableData) {
        var uniqueData = [];
        this.tableData.map((item) => {
          if (
            !this.jpReceTransSelectForm.some(
              (tableItem) =>
                item.jrdOrderNo === tableItem.jrdOrderNo &&
                item.jrdDetailNo === tableItem.jrdDetailNo &&
                item.jrdProdExKbn === tableItem.jrdProdExKbn
            )
          ) {
            uniqueData.push(item);
          }
        });

        // if (uniqueData.length > 0) {
        //   for (let index = 0; index < uniqueData.length; index++) {
        //     const element = uniqueData[index];
        //     this.jpReceTransSelectForm.push(element);
        //   }
        // }

        this.tableData.forEach((row) => {
          for (
            let index = 0;
            index < this.jpReceTransSelectForm.length;
            index++
          ) {
            const element = this.jpReceTransSelectForm[index];

            //詳細画面選択のデータ選択チェックボックス
            if (
              row.jrdOrderNo == element.jrdOrderNo &&
              row.jrdDetailNo == element.jrdDetailNo &&
              row.jrdProdExKbn == element.jrdProdExKbn
            ) {
              this.$nextTick(() => {
                this.$refs.jpReceTransSelectForm.toggleRowSelection(
                  this.jpReceTransSelectForm[index],
                  true
                );
              });
              this.tableData[row.index] = this.jpReceTransSelectForm[index];
              if (row.editCloseFlg == STR_ONE) {
                this.jpReceTransSelectForm[index].editCloseFlg = STR_ONE;
              } else {
                this.jpReceTransSelectForm[index].editCloseFlg = STR_ZERO;
              }
            } else {
              continue;
            }
          }
        });
      }
      // データ処理
      this.dataProcess();
    },

    selectableCheck(row, index) {
      if (row.editCloseFlg === STR_ONE) {
        return false;
      } else {
        return true;
      }
    },

    //検索条件の調整
    updateSearchForm() {
      this.searchConditionForm.searchOrderNo =
        this.searchConditionForm.searchOrderNo.trim();
      this.searchConditionForm.searchDrawNo =
        this.searchConditionForm.searchDrawNo.trim();

      //日付の設定
      if (this.dateRange) {
        this.searchConditionForm.searchStartDate = formatDateToString(
          this.dateRange[0]
        );
        this.searchConditionForm.searchEndDate = formatDateToString(
          this.dateRange[1]
        );
      } else {
        this.searchConditionForm.searchStartDate = STR_EMPTY;
        this.searchConditionForm.searchEndDate = STR_EMPTY;
      }
    },

    //列幅に自動調整
    FlexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.jpReceTransSelectForm);
    },

    //确定ボタン
    confirmClick() {
      let data = this.$refs.jpReceTransSelectForm.selection;

      if (!!data && data.length > 0) {
        this.selectedProcForm = data;
        var result = [
          { key: "selectedProcForm", value: this.selectedProcForm },
          { key: "searchConditionForm", value: this.searchConditionForm },
        ];
        this.$emit("ok", result);
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      if (typeof this.$refs.confirmBtn !== "undefined") {
        // フォーカス削除
        this.$refs.confirmBtn.$el.blur();
      }
    },

    // 製品異常
    rowClassName({ row }) {
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      // if (row.jrdProdExKbn == STR_TWO) {
      //   return "textColor";
      // }
      var prodExKbnShow = ShowMergeExKbn(
        row.jrdProdExKbn,
        row.jrdProdReceExKbn
      );
      if (prodExKbnShow !== NORMAL_PROD) {
        return "textColor";
      }
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.jpReceTransSelectForm);
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
</style>
